import createReactComponent from '../createReactComponent';
export default createReactComponent('direction', 'IconDirection', [
  ['path', { d: 'M9 10l3 -3l3 3', key: 'svg-0' }],
  ['path', { d: 'M9 14l3 3l3 -3', key: 'svg-1' }],
]);
